import React from "react"

export const tableColumnAlign = (text: string, alignment: AlignSetting) => {
  return <p style={{ textAlign: alignment }}>{text}</p>
}
